import { useEffect, useMemo } from 'react'
import { Modal, Platform, Pressable } from 'react-native'
import { usePathname } from 'expo-router'
import { useTheme } from '../../../theme/useTheme'
import { useOperatorWebPaletteUiStore } from '../../stores/operatorWebPaletteUiStore'
import { getOperatorWebPaletteModalChromeStyles } from './OperatorWebPalette.styles'
import { OperatorWebPalettePanel } from './OperatorWebPalette'

/**
 * Portal overlay for the operator palette — URL stays on the current marketing route.
 */
export function OperatorWebPaletteHost() {
  const pathname = usePathname() ?? ''
  const theme = useTheme()
  const modalChrome = useMemo(() => getOperatorWebPaletteModalChromeStyles(theme), [theme])
  const visible = useOperatorWebPaletteUiStore((s) => s.visible)
  const close = useOperatorWebPaletteUiStore((s) => s.close)

  useEffect(() => {
    if (pathname.startsWith('/app')) close()
  }, [close, pathname])

  if (Platform.OS !== 'web') {
    return null
  }

  return (
    <Modal visible={visible} transparent animationType="fade" onRequestClose={close}>
      <Pressable style={modalChrome.backdrop} onPress={close}>
        <Pressable style={modalChrome.card} onPress={(e) => e.stopPropagation()}>
          {visible ? <OperatorWebPalettePanel onClose={close} /> : null}
        </Pressable>
      </Pressable>
    </Modal>
  )
}
